import { Modal, ModalBody, ModalFooter } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import {
  REMOVE_SITE_MODAL_TITLE,
  REMOVE_MODAL_MESSAGE_PREFIX,
  REMOVE_SITE_MODAL_MESSAGE_SUFFIX,
  REMOVE_SITE_MODAL_SAVE_NOTE,
  MODAL_CONFIRM_REMOVE_BUTTON,
  MODAL_CANCEL_BUTTON
} from "../../global/constants/userDetailsConstants";

const RemoveSiteModal = ({ opened, siteToRemove, onConfirm, onClose }) => {
  return (
    <Modal
      opened={opened}
      hideCloseButton={false}
      className="modal-confirmation"
      disableOutsideClick={true}
      onClose={onClose}
    >
      <Title size="large" bold primitive="h2" viewport="desktop">
        {REMOVE_SITE_MODAL_TITLE}
      </Title>
      <ModalBody>
        <Body size="medium" viewport="desktop" primitive="span">
          <div>
            <p className="modal-confirmation-text">
              {REMOVE_MODAL_MESSAGE_PREFIX} <strong>{siteToRemove?.userName}</strong> {REMOVE_SITE_MODAL_MESSAGE_SUFFIX} <strong>{siteToRemove?.siteName}</strong>?
            </p>
            <p className="modal-confirmation-text">
              {REMOVE_SITE_MODAL_SAVE_NOTE}
            </p>
            <ModalFooter
              buttonData={{
                primary: {
                  "data-testid": "userdetails_confirmRemoveSiteButton",
                  className: "modal-button-width",
                  children: MODAL_CONFIRM_REMOVE_BUTTON,
                  onClick: onConfirm,
                },
                close: {
                  "data-testid": "userdetails_denyRemoveSiteNoButton",
                  children: MODAL_CANCEL_BUTTON,
                  className: "modal-button-width",
                  onClick: onClose,
                },
              }}
            />
          </div>
        </Body>
      </ModalBody>
    </Modal>
  );
};

export default RemoveSiteModal;
